import React from "react"
import { useSiteMetadata } from "../hooks/useSiteMetadata"
import { TELEGRAM_KANAL, WHATSAPP_KANAL, INSTAGRAM_HESABI } from "../consts/Kanallar";

// Paylaşım önizlemesi (WhatsApp / Telegram / X / Facebook) varsayılan görseli: static/og-gorsel.png (1200x630, yeni logo).
// Önizleme botları JS çalıştırmaz ve göreli adresi açamaz: tam adres verilir.
const OG_GORSEL = "/og-gorsel.png";
// Google `keywords` etiketini okumuyor; yine de her sayfada aynı mağaza listesi durmasın (n11 sayfasında "Trendyol indirim"
// yazıyordu). Sayfanın kendi kelimeleri + kısa genel liste (2026-11-05).
const VARSAYILAN_ANAHTARLAR = "gerçek indirim, fiyat geçmişi, indirim kodu, kupon, İndirim Uzmanı";

/**
 * Google'ın markayı tanıması için yapılandırılmış veri (schema.org): kuruluş (ad, logo, sosyal hesaplar) + web sitesi.
 * Sadece ana sayfada (`kurum` prop'u) basılır.
 */
function kurumVerisi(siteUrl) {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": siteUrl + "/#kurum",
        name: "İndirim Uzmanı",
        url: siteUrl + "/",
        logo: siteUrl + "/logo-512.png",
        sameAs: [INSTAGRAM_HESABI, TELEGRAM_KANAL, WHATSAPP_KANAL],
      },
      {
        "@type": "WebSite",
        "@id": siteUrl + "/#site",
        name: "İndirim Uzmanı",
        url: siteUrl + "/",
        inLanguage: "tr-TR",
        publisher: { "@id": siteUrl + "/#kurum" },
      },
    ],
  };
}

/**
 * Google sonuçlarında sayfa yolu (Ana sayfa > Sayfa). Ana sayfa dışındaki açık sayfalarda otomatik; sayfanın adı başlığın
 * ":" / "|" öncesi ("En Yeni Trendyol İndirimleri", "Elektronik İndirimleri").
 */
function kirintiVerisi(siteUrl, url, title) {
  const ad = String(title || "").split(/[:|]/)[0].trim();
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "İndirim Uzmanı", item: siteUrl + "/" },
      { "@type": "ListItem", position: 2, name: ad, item: url },
    ],
  };
}

/**
 * Sayfa başlığı ve meta etiketleri. `pathname` verilen sayfa Google'a açıktır (canonical ile); verilmeyen sayfa
 * (indirim detayı, arama sonucu: kısa ömürlü) `noindex, follow`. `noindex` = adresi olsa da Google'a kapalı (çoğu zaman boş
 * kalan editör seçimi sayfaları, 2026-11-05).
 */
export const Seo = ({ title, description, keywords, pathname, image, kurum, noindex, children }) => {
  const { title: defaultTitle, description: defaultDescription, siteUrl } = useSiteMetadata()
  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    url: `${siteUrl}${pathname || ``}`,
    image: image || `${siteUrl}${OG_GORSEL}`,
    keywords: keywords ? keywords + ", " + VARSAYILAN_ANAHTARLAR : VARSAYILAN_ANAHTARLAR,
  }
  return (
    <>
      <html lang="tr" />
      <title>{seo.title}</title>
      <meta name="google-site-verification" content="lIuyvWFVgCkP6uweKIF3fIYtn8Kp9USr8EJFo__lLqk" />
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      <meta name="image" content={seo.image} />
      <meta name="theme-color" content="#ef3b2d" />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:site_name" content="İndirim Uzmanı" />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      {!image && <meta property="og:image:width" content="1200" />}
      {!image && <meta property="og:image:height" content="630" />}
      {pathname && <meta property="og:url" content={seo.url} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      {/* sekme simgesi: yeni logo simgesi (SVG; manifest eklentisi PNG boyutlarını ve apple-touch-icon'u ayrıca ekliyor).
          Eskiden burada elle kırmızı çizgi SVG'si vardı ve manifest simgesini eziyordu. */}
      <link rel="icon" type="image/svg+xml" href="/logo-simge.svg" />
      {pathname && !noindex ? <link rel="canonical" href={seo.url} /> : <meta name="robots" content="noindex, follow" />}
      {kurum && <script type="application/ld+json">{JSON.stringify(kurumVerisi(siteUrl))}</script>}
      {pathname && !noindex && !kurum && pathname !== "/" &&
        <script type="application/ld+json">{JSON.stringify(kirintiVerisi(siteUrl, seo.url, seo.title))}</script>}
      {children}
    </>
  )
}
